<template>
    <div>
        <div
            v-if="userHoroscope"
            class="container horoscope">
            <h2>{{ $t("advices") }}</h2>

            <div class="grid">
                <div class="grid__item desktop--4">
                    <h3 class="horoscope__section-title">
                        <img
                            :src="require('@/assets/images/artworks/horoscope/love.svg')"
                            :alt="$t('love')" />
                    </h3>

                    <p
                        class="horoscope__content"
                        v-html="capitalize(userHoroscope.love)"></p>

                </div>
                <div class="grid__item desktop--4">
                    <h3 class="horoscope__section-title">
                        <img
                            :src="require('@/assets/images/artworks/horoscope/work.svg')"
                            :alt="$t('work')" />
                    </h3>

                    <p
                        class="horoscope__content"
                        v-html="capitalize(userHoroscope.work)"></p>
                </div>
                <div class="grid__item desktop--4">
                    <h3 class="horoscope__section-title">
                        <img
                            :src="require('@/assets/images/artworks/horoscope/health.svg')"
                            :alt="$t('finance')" />
                    </h3>

                    <p
                        class="horoscope__content"
                        v-html="capitalize(userHoroscope.finance)"></p>
                </div>
            </div>

            <br />
            <br />
            <p>&#169; Serge Ducas {{ $dayjs().year() }}</p>

        </div>
        
    </div>
</template>

<script>
// @ is an alias to /src


import axios from "axios";

import {SIGNS} from "@/utils/constants/zodiac.js";

export default {
    name: "HoroscopeText",
    components : {
        
    }, 
    props : {
        cycle:{
            type : Array,
            required : true
        }, 
        currentSign : {
            type : String,
            required : true 
        }
    },
    data() {
        return {
           
        };
    },
    computed : {
        horoscope() {
            return this.$store.getters["constantModule/getHoroscope"];
        },
       
        userHoroscope() {
            if (this.horoscope && this.currentSign) {
                const sign = SIGNS[this.currentSign];
                const signIndex = this.getObjetIndexByKey(this.horoscope, "sign", sign);

                if (signIndex > -1) {
                    return this.horoscope[signIndex];
                }
            }
        },
      
    },
    mounted () {
        if (!this.horoscope) {
            this.fetchHoroscope();
        }
       
    },
    methods : {
        fetchHoroscope() {
            const currentLocal = this.$i18n.locale;

            axios({
                url: `/json/horoscope/horoscope.${currentLocal}.json`,
            }).then(res => {
                this.$store.commit("constantModule/setHoroscope", res.data);
            }).catch(e => {
                if (e.response) {
                    throw e.response;
                }
            });
        },
    }
};
</script>
